import React, { useContext } from 'react'
import styled from '@emotion/styled'
import { array, bool, object, string } from 'prop-types'
import Media from 'react-media'
import { JsonLd } from 'react-schemaorg'

// Import Components
import { CategoryBody } from './CategoryBody'
import { AdsenseContext, ArticleSchema, ContentHeroBanner, DfpAdUnitSetup, Layout } from '@jelly/components'
import { SECTION_CONTAINER, SECTION_WIDGET } from '../constants'

// Styled Components via Emotion
const CategoryContainer = styled.div`
	height: 100%;
	width: 100%;
`

Category.propTypes = {
	author: object.isRequired,
	canonical: string.isRequired,
	breadcrumbs: object.isRequired,
	channels: object.isRequired,
	docType: string.isRequired,
	guid: string.isRequired,
	hasVwo: bool,
	lastModified: string.isRequired,
	meta: object.isRequired,
	published: string.isRequired,
	sections: array.isRequired,
	structuredData: object,
	thumbnail: object.isRequired,
	title: string.isRequired,
	tocElements: array.isRequired,
}

/**
 * This is the Category Template Wrapper
 */
export function Category(props) {
	const {
		author,
		breadcrumbs,
		canonical,
		channels,
		docType,
		guid,
		hasVwo,
		lastModified,
		published,
		meta,
		sections,
		structuredData,
		thumbnail,
		title,
		tocElements,
	} = props

	// join all container sections for the article schema data
	const content = sections
		.filter((section) => section.type === SECTION_CONTAINER)
		.map((section) => {
			return section.container.html
		})
	const widgetId = sections.find((section) => section.type === SECTION_WIDGET)?.widget?.widgetId

	const { adsenseMediaQuery, hasAdsense } = useContext(AdsenseContext)

	return (
		<CategoryContainer>
			<Layout meta={meta} hasVwo={hasVwo}>
				<JsonLd
					item={ArticleSchema({
						thumbnail,
						content: content.join(' '),
						author,
						canonical,
						breadcrumbs,
						published,
						lastModified,
						title,
					})}
				/>
				{structuredData && <JsonLd item={structuredData} />}
				<ContentHeroBanner
					author={author}
					breadcrumbs={breadcrumbs}
					date={lastModified}
					published={published}
					header={title}
					imageSrc={thumbnail}
				/>
				<CategoryBody
					docType={docType}
					guid={guid}
					sections={sections}
					title={title}
					tocElements={tocElements}
					widgetId={widgetId}
				/>
				{hasAdsense && (
					<Media query={adsenseMediaQuery} defaultMatches={false}>
						{(matches) => matches && <DfpAdUnitSetup channels={channels} docType={docType} guid={guid} />}
					</Media>
				)}
			</Layout>
		</CategoryContainer>
	)
}
